export const regexName = /^[a-z0-9](([a-z0-9 _+-.,])+)?$/gi;
export const regexFloat = /^\d*\.?\d+$/;
